import React, { lazy } from 'react'

import usePermissions from 'hooks/usePermissions'
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

const UnauthorizedPage = lazy(() => import('views/UnauthorizedPage/UnauthorizedPage'))

export default function PermissionRoute({ children, permissions }) {
  const { authorized, loading } = usePermissions(permissions)

  if (loading) return <LoadingSpinner />
  if (!authorized) return <UnauthorizedPage />

  return children
}
